export enum UserTypes {
    Admin = 'Admin',
    Viewer = 'Viewer',
    Api = 'API',
}
export const AdminViewer = [UserTypes.Admin, UserTypes.Viewer];
export const AdminApi = [UserTypes.Admin, UserTypes.Api];
